import { render, staticRenderFns } from "./AppIcon.vue?vue&type=template&id=4a7ca369&"
import script from "./AppIcon.vue?vue&type=script&lang=ts&"
export * from "./AppIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports